// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","localPanelBody":"panel-loader__localPanelBody___Bvu72","loaderContainer":"panel-loader__loaderContainer___X7kT5"};